export const PRECIOS_CLIENTE_REQ = "PRECIOS_CLIENTE_REQUEST";
export const PRECIOS_CLIENTE_REQ_ERROR = "PRECIOS_CLIENTE_REQ_ERROR";
export const PRECIOS_CLIENTE_ADD_TAB = "PRECIOS_CLIENTE_ADD_TAB";
export const PRECIOS_CLIENTE_REMOVE_TAB = "PRECIOS_CLIENTE_REMOVE_TAB";
export const PRECIOS_CLIENTE_HANDLE_SEARCH = "PRECIOS_CLIENTE_HANDLE_SEARCH";
